<div class="system-bet-linear__container">
    <bs-linear-module-container
        [expandable]="true"
        [defaultExpanded]="defaultExpanded()"
        [trackingBetslipTypeContext]="betslipType"
        (expandedChanged)="toggleExpand($event)">
        <ng-template [bsLinearModuleHeader]>
            <div class="system-bet-linear__system-info">
                <div class="system-bet-linear__title-icon">
                    <span class="system-bet-linear__title"> {{ sitecore.betslip.linear.SystemTitle }} </span>
                </div>
            </div>
        </ng-template>

        <ng-template [bsLinearModuleContent]>
            <bs-system-bet-bar-linear />
            <bs-linear-container-errors [betslipType]="betslipType" />
            @if (showPickList()) {
                @if (viewModel(); as viewModel) {
                    <div class="system-bet-linear__pick-list">
                        <bs-digital-pick-list>
                            @for (pick of viewModel.pickList; track pickTrackBy($index, pick)) {
                                <bs-digital-system-bet-pick
                                    [pick]="pick"
                                    [systemBetPick]="systemBetPick(viewModel.systemBetState, pick)"
                                    [systemBetState]="viewModel.systemBetState"
                                    [oddsDisplayFormat]="oddsDisplayFormat"
                                    [removeButtonPosition]="removeButtonPosition"
                                    [removeButtonStyle]="removeButtonStyle"
                                    [isSelectionCheckboxVisible]="showSelectionCheckboxes()"
                                    [isLinearContext]="true" />
                            }
                        </bs-digital-pick-list>
                    </div>
                }
            }
            <bs-system-bet-types-list [oddsDisplayFormat]="oddsDisplayFormat" />
        </ng-template>
    </bs-linear-module-container>
</div>
